export const pidToTxData = (pid) => {
    if (!/^([\dA-Za-z]{2})*$/u.test(pid)) {
        throw new Error(`chfv2 pid must be a string and have an even number of hex digits to convert to uint8array`);
    }
    const numBytes = pid.length / 2;
    const pidBytes = new Uint8Array(numBytes);
    for (let i = 0; i < numBytes; i++) {
        pidBytes[i] = parseInt(pid.slice(i * 2, i * 2 + 2), 16);
    }
    return pidBytes;
};
